"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImportMetaObfuscationGuard = void 0;
const inversify_1 = require("inversify");
const ObfuscatingGuardResult_1 = require("../../../enums/node/ObfuscatingGuardResult");
const NodeGuards_1 = require("../../../node/NodeGuards");
let ImportMetaObfuscationGuard = class ImportMetaObfuscationGuard {
    check(node) {
        const isMetaProperty = NodeGuards_1.NodeGuards.isMetaPropertyNode(node);
        const isMetaPropertyParent = !!(node === null || node === void 0 ? void 0 : node.parentNode) && NodeGuards_1.NodeGuards.isMetaPropertyNode(node.parentNode);
        return isMetaProperty || isMetaPropertyParent ? ObfuscatingGuardResult_1.ObfuscatingGuardResult.Ignore : ObfuscatingGuardResult_1.ObfuscatingGuardResult.Transform;
    }
};
exports.ImportMetaObfuscationGuard = ImportMetaObfuscationGuard;
exports.ImportMetaObfuscationGuard = ImportMetaObfuscationGuard = __decorate([
    (0, inversify_1.injectable)()
], ImportMetaObfuscationGuard);
